import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  closeActivityCategoryModel,
  openActivityListModel,
} from "../../store/slices/modalSlice";
import { useEffect, useMemo, useState } from "react";
import { Activity, getDataForDedActivityCategoryPageApi } from "../../lib/api";
import { setActivityCategory } from "../../store/slices/IdSlice";

const ActivityCategory = () => {
  const dispatch = useDispatch();
  const activityCategoryModel = useSelector(
    (state: { modal: { activityCategoryModel: boolean } }) =>
      state.modal.activityCategoryModel
  );

  const [activities, setActivities] = useState<Activity[]>([]);
  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(false);

  // Fetch from API
  useEffect(() => {
    import("./DedActivityCss.css");
    const fetchActivities = async () => {
      setLoading(true);
      try {
        const data = await getDataForDedActivityCategoryPageApi();
        setActivities(data);
      } catch (err) {
        console.error("Failed to fetch activities:", err);
      } finally {
        setLoading(false);
      }
    };
    if (activityCategoryModel) fetchActivities();
  }, [activityCategoryModel]);

  const filteredActivities = useMemo(() => {
    if (!query) return activities;
    const lowerQuery = query.toLowerCase();
    return activities.filter((category) => {
      const categoryMatches = category.name.toLowerCase().includes(lowerQuery);
      const subActivityMatches = category.subActivities?.some((sub) =>
        sub.activityCode.toLowerCase().includes(lowerQuery)
      );
      return categoryMatches || subActivityMatches;
    });
  }, [query, activities]);

  const handleCloseModal = () => {
    dispatch(closeActivityCategoryModel());
  };

  const handleGetActivityList = (categoryID: number, slug: string) => {
    dispatch(setActivityCategory({ catId: categoryID, slug }));
    dispatch(openActivityListModel());
    dispatch(closeActivityCategoryModel());
  };

  return (
    <Modal
      show={activityCategoryModel}
      onHide={handleCloseModal}
      scrollable
      centered
      backdrop="static"
      className="mb-fix slide-from-bottom activity-modal"
    >
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body className="modal-dialog-scrollable pt-0">
        <h3 className="modal-title text-uppercase text-center font-20 ff-semibold py-3 m-0 border-bottom-1pt">
          Please choose the main category
        </h3>
        <div className="act-activity-category-section">
          <div className="search-section-act bg-gray-act">
            <div className="secrch-box-act">
              <input
                className="form-control font-12"
                type="text"
                placeholder="Search activity"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
              />
              <span className="search-icon-act">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="11" cy="11" r="8"></circle>
                  <path d="M21 21L16.65 16.65"></path>
                </svg>
              </span>
            </div>
          </div>
          {loading && <div className="col-12">Loading activities...</div>}

          {!loading && (
            <ul className="grid-three-sec-act">
              {filteredActivities.map((item) => (
                <li
                  key={item.categoryID}
                  className="category-card-act"
                  onClick={() =>
                    handleGetActivityList(item.categoryID, item.slug)
                  }
                >
                  <div className="cate-img-act">
                    <img
                      src={item.iconUrl}
                      alt={item.name}
                      className="img-fluid"
                    />
                  </div>
                  <div className="cate-text-act">
                    <h6 className="font-12 ff-semibold">{item.name}</h6>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ActivityCategory;
